import { render } from "./ListeArticle.vue?vue&type=template&id=4d9fd2c7&ts=true"
import script from "./ListeArticle.vue?vue&type=script&lang=ts"
export * from "./ListeArticle.vue?vue&type=script&lang=ts"

import "./ListeArticle.vue?vue&type=style&index=0&id=4d9fd2c7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__